<!--
 * @Description:自动分配考场地点
 * @Author: WLX
 * @Date: 2023-05-16 13:41:07
 * @LastEditors: WLX
 * @LastEditTime: 2023-05-22 11:14:08
-->
<template>
    <div class="tan-chuang">
      <el-dialog class="w600 h430" :model-value="openZdfpkcdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Edit />
            </el-icon>
            <span class="header-title">自动分配考场地点</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="closeWindow('openZdfpkcdd', emits, false)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="考场地点" prop="kcddids" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <!-- 多选 BEGIN -->
                <div class="an-niu wp100">
                  <el-button type="primary" class="w180" @click="openlljxcdDuoTiao=true;row={ids:lljxcdidData}">选择</el-button>
                  <el-button link v-if="lljxcdData.length" @click="lljxcdData=[];lljxcdidData=[]">清空</el-button>
                </div>
                <div class="biao-qian" v-if="lljxcdData.length">
                  <el-tag class="mr10 mt10" v-for="(item, index) in lljxcdData" :key="index" closable :disable-transitions="false" @close="YiChu(index)">
                    {{ item.jsbh }}
                  </el-tag>
                </div>
                <!-- 多选 END -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
            <div></div>
            <div class="footer_but">
                <el-button type="primary" @click="submit()">保存</el-button>
                <el-button type="info" @click="closeWindow('openZdfpkcdd', emits, false)">关闭</el-button>
            </div>
          </div>
        </template>
      </el-dialog>
    </div>
    <jiaoxuechangdiduotiao v-if="openlljxcdDuoTiao" v-model:openDuoTiao="openlljxcdDuoTiao" :row="row" @ReturnData="lljxcdReturnData"/>
  </template>
  
  <script setup>
  import { defineProps, defineEmits, ref, watch, unref } from 'vue'
  import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
  import jiaoxuechangdiduotiao from '@/components/chazhaodaihui/jiaoxuechangdiduotiao.vue'
  
  const props = defineProps({ 
    openZdfpkcdd: { type: Boolean, required: true },
    row: { type: Object, required: false } })
  const emits = defineEmits(['update:openZdfpkcdd', 'ReturnData'])
  const ruleFormRef = ref(null)
  const ruleForm = ref({})
  
  const row = ref()
  watch(
    () => props.openZdfpkcdd,
    () => {
      if (props.openZdfpkcdd) {
        row.value = props.row
        // 
        ruleForm.value.pkjhid = props.row.id || ''
      }
    },
    { deep: true, immediate: true }
  )
  
  // 提交
  const submit = async () => {
    ruleForm.value.kcddids = lljxcdidData
    submitForm({
      url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/zidongfenpeikaoshididian',
      ruleFormRef: unref(ruleFormRef),
      ruleForm: ruleForm.value,
      callback: function (res) {
        closeWindow('openZdfpkcdd', emits, true)
      }
    })
  }

  // 考场地点
  const openlljxcdDuoTiao = ref(false)
  const lljxcdData = ref([])
  const lljxcdidData = ref([])
  const lljxcdReturnData = (data) => {
    lljxcdData.value = data || []
    lljxcdidData.value = data.map((item) => item.id)
  }
  // 移出
  const YiChu = (index) => {
      lljxcdData.value.splice(index, 1)
      lljxcdidData.value.splice(index, 1)
  }

</script>
  